import { Component, OnInit } from '@angular/core';
import { ErrorParser } from '@app/classes';
import { Department } from '@app/models/company/department.model';
import { AuthService, NotifyService } from '@app/services';
import { JournalEntryReportItemTemplate } from '@app/models/payroll/journal-entry-reports-settings-line-item.model';
import { JournalEntryReportService } from '../../services/journal-entry-report.service';

@Component({
    templateUrl: './journal-entry-report-settings.template.html',
})
export class JournalEntryReportSettingsView implements OnInit {
    departments: Department[];
    journalEntryReportItemTemplates: JournalEntryReportItemTemplate[] = [];

    constructor(
        private journalEntryReportService: JournalEntryReportService,
        private notify: NotifyService,
        private auth: AuthService
    ) {}

    async ngOnInit(): Promise<void> {
        this.departments = await this.fetchDepartments();
        this.journalEntryReportItemTemplates =
            await this.journalEntryReportService.fetchJournalEntryReportLineItemsTemplates();
    }

    async saveReportItemTemplateChange(reportItemTemplateChange: JournalEntryReportItemTemplate): Promise<void> {
        try {
            await this.journalEntryReportService.saveJournalEntryReportItemTemplate(reportItemTemplateChange);
        } catch (error) {
            this.notify.error(ErrorParser.parse(error));
        }
    }

    async saveDepartment(department: Department): Promise<void> {
        try {
            await this.journalEntryReportService.saveDepartment(department, this.auth.company.id);
        } catch (error) {
            this.notify.error(ErrorParser.parse(error));
        }
    }

    private async fetchDepartments(): Promise<Department[]> {
        const [departments] = await Department.param('company', this.auth.company.id).all();
        return departments;
    }
}
